module.exports = __webpack_public_path__ + "static/graph-top-6142abef1ade9566c5b89a2baf0519cb.png";